import { RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useVersionCheck } from "../hooks/useVersionCheck";

export function VersionUpdateBanner() {
  const { isNewVersionAvailable, reloadApp } = useVersionCheck();
  const { t } = useTranslation();

  if (!isNewVersionAvailable) {
    return null;
  }

  return (
    <div
      className="fixed top-2 right-2 z-50 bg-blue-600 text-white text-xs px-2 py-1 rounded shadow-lg flex items-center gap-1.5 cursor-pointer hover:bg-blue-700 transition-colors"
      onClick={reloadApp}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          reloadApp();
        }
      }}
    >
      <RefreshCw className="h-3 w-3" />
      <span>{t("versionUpdateBanner.newVersion")}</span>
    </div>
  );
}
